import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

type Props = {
  readonly crumbs: readonly string[];
  readonly inboxCount?: number;
  readonly topbarAction?: ReactNode;
  readonly children: ReactNode;
};

export function AppShell({ crumbs, inboxCount, topbarAction, children }: Props) {
  return (
    <div className="app">
      <Sidebar inboxCount={inboxCount} />
      <Topbar crumbs={crumbs} action={topbarAction} />
      <main className="main">{children}</main>
    </div>
  );
}
